import { useTranslation } from 'react-i18next';
import { WREG_ASIDE, WREG_PHOTO_LIST, wregGroup, wregPhoto, type WregStep } from './wregSteps';

type Props = {
  step: WregStep;
};

const WregAside = ({ step }: Props) => {
  const { t } = useTranslation();
  const key = WREG_ASIDE[wregGroup(step)];
  const photo = wregPhoto(step);
  return (
    <div className="reg-dt-aside wreg-aside">
      <div className="wreg-aside-photos" aria-hidden="true">
        {WREG_PHOTO_LIST.map((src) => (
          <img
            key={src}
            className={`wreg-aside-photo${src === photo ? ' on' : ''}`}
            src={src}
            alt=""
          />
        ))}
      </div>
      <div className="reg-dt-aside-quote">{t(key)}</div>
    </div>
  );
};

export { WregAside };
